import { ParentGuardianInfoSubmitter } from '../../lib/parent-guardian-info/parent-guardian-info-submit.service'
import { DocsParentGuardianInfoSubmitter } from './docs-parent-guardian-info-submitter.service'

export const PROVIDERS = [
  {
    provide: ParentGuardianInfoSubmitter,
    useClass: DocsParentGuardianInfoSubmitter,
  }
]
